const companyBasePath = '/companies';


const CompanyConst = {
  basePath     : companyBasePath
};

export default CompanyConst;